import React from "react";
import { api } from "api";
import { RouteComponentProps, Redirect } from "react-router";

type HomePageProps = RouteComponentProps & {};

export const HomePage: React.FC<HomePageProps> = ({}) => {
  return api.isLoggedIn ? <Redirect to="/manage" /> : <Redirect to="/login" />;
};
